const $ = jQuery.noConflict();
'use strict';

const contactFormSelect = {
	init: function() {
		$(document).ready(function() {
			if ($('.contact-form').length) {
				const urlParams = new URLSearchParams(window.location.search);
				const subjectValue = urlParams.get('subject');
				const select = $('.js-option-name-values');

				if (subjectValue && select.length) {
					const availableOptions = [];
					$('.js-option-name-values option').each(function() {
						availableOptions.push($(this).val());
					});

					if (availableOptions.includes(subjectValue)) {
						setTimeout(function() {
							select.val(subjectValue).change();
						}, 300);
					}
				}
			}
		});
	},
};

export default contactFormSelect;
